import { render, staticRenderFns } from "./my-index.vue?vue&type=template&id=a669acc0&scoped=true&"
import script from "./my-index.vue?vue&type=script&lang=js&"
export * from "./my-index.vue?vue&type=script&lang=js&"
import style0 from "./my-index.vue?vue&type=style&index=0&id=a669acc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a669acc0",
  null
  
)

export default component.exports